// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmUnfavorite_modal__Ef6aq","card":"ConfirmUnfavorite_card__xnq1S"};